import { render, staticRenderFns } from "./Dialog_UpdateClass.vue?vue&type=template&id=6dac3797&scoped=true&"
import script from "./Dialog_UpdateClass.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac3797",
  null
  
)

export default component.exports